document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-nuora-variant]')) return;
  var selected = event.target.selectedOptions[0];
  var price = document.querySelector('[data-nuora-price]');
  if (selected && price) price.textContent = selected.dataset.price || '';
});

(function () {
  function cardStep(rail) {
    var card = rail.firstElementChild;
    if (!card) return Math.max(280, rail.clientWidth * 0.8);
    var styles = window.getComputedStyle(rail);
    return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
  }

  function updateCarousel(container) {
    var rail = container.querySelector('[data-nuora-carousel-rail]');
    if (!rail) return;
    var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var previous = container.querySelector('[data-nuora-carousel-button="previous"]');
    var next = container.querySelector('[data-nuora-carousel-button="next"]');
    if (previous) previous.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= maximum - 2;
    var progress = container.querySelector('.nuora-proof__progress span');
    if (progress) {
      var visible = maximum ? Math.min(100, 35 + (rail.scrollLeft / maximum) * 65) : 100;
      progress.style.setProperty('--nuora-progress', visible + '%');
    }
  }

  function scrollCarousel(container, direction) {
    var rail = container.querySelector('[data-nuora-carousel-rail]');
    if (!rail) return;
    rail.scrollBy({ left: direction * cardStep(rail), behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-nuora-carousel-button]');
    if (!button) return;
    var container = button.closest('[data-nuora-carousel]');
    if (!container) return;
    scrollCarousel(container, button.dataset.nuoraCarouselButton === 'previous' ? -1 : 1);
  });

  function initializeCarousel(container) {
    var rail = container.querySelector('[data-nuora-carousel-rail]');
    if (!rail || rail.dataset.nuoraReady) return;
    rail.dataset.nuoraReady = 'true';
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    rail.addEventListener('scroll', function () { updateCarousel(container); }, { passive: true });
    rail.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      scrollCarousel(container, event.key === 'ArrowLeft' ? -1 : 1);
    });
    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
      rail.setPointerCapture(event.pointerId);
      rail.classList.add('is-dragging');
    });
    rail.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var distance = event.clientX - startX;
      if (Math.abs(distance) > 4) moved = true;
      rail.scrollLeft = startScroll - distance;
    });
    function stopDragging(event) {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-dragging');
      if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
    }
    rail.addEventListener('pointerup', stopDragging);
    rail.addEventListener('pointercancel', stopDragging);
    rail.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
    updateCarousel(container);
  }

  function initializeAll() {
    document.querySelectorAll('[data-nuora-carousel]').forEach(function (container) {
      initializeCarousel(container);
      updateCarousel(container);
    });
  }
  initializeAll();
  window.addEventListener('resize', initializeAll, { passive: true });
})();
